import { useContext } from "react";
import ThemeContext from "../store/theme-context";

const PageNotFound = () => {
    const theme = useContext(ThemeContext);

    return ( 
        <div className="videos" style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <h2>Ooooops, Page Not Found!</h2>
        </div>
     );
}
 
export default PageNotFound;